module.exports = __webpack_public_path__ + "static/img/ranking cursos 1024x768.74e6cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/populares/ranking cursos 1024x768.jpg
// module id = p1nU
// module chunks = 47